// @file Tailwind utility functions
import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combine and compress Tailwind classNames.
 * @see https://github.com/padlet/rn-mobile-app/blob/master/packages/tailwind/src/utils/cn.ts
 */
function cn(...inputs: clsx.ClassValue[]): string {
  return twMerge(clsx(...inputs))
}

export { cn }
